export enum State {
  IDLE = 'IDLE',
  INITIALIZATION = 'INITIALIZATION',
  ADMINISTRATION = 'ADMINISTRATION',
  PAIRING = 'PAIRING',
  SIGNAGE = 'SIGNAGE',
  SIGNAGE_PREVIEW = 'SIGNAGE_PREVIEW'
}
